import { render, staticRenderFns } from "./product1.vue?vue&type=template&id=203ac74a&scoped=true"
import script from "./product1.vue?vue&type=script&lang=js"
export * from "./product1.vue?vue&type=script&lang=js"
import style0 from "./product1.vue?vue&type=style&index=0&id=203ac74a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203ac74a",
  null
  
)

export default component.exports